import { render, staticRenderFns } from "./PayoutSetting.vue?vue&type=template&id=3e475601"
import script from "./PayoutSetting.vue?vue&type=script&lang=js"
export * from "./PayoutSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports